module.exports = __webpack_public_path__ + "img/sol_cap3.169d874b.png";